import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconMakePaymentProps } from './IconMakePayment.types'
import * as Styled from './styles/IconMakePayment.style'

import { nonThemeableRules } from '../../ruleSet'

const IconMakePayment: FC<IconMakePaymentProps> = ({
  size = nonThemeableRules.defaultSize as number as IconMakePaymentProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconMakePaymentProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path d='M14.418 11.031a1.339 1.339 0 1 1-2.674.002 1.339 1.339 0 0 1 2.674-.002Zm0 0' vectorEffect='non-scaling-stroke' />
          <path
            d='M6.43 6.39h15.082v7.536a1.783 1.783 0 0 1-1.782 1.781H6.43a1.775 1.775 0 0 1-1.782-1.777V8.18c-.003-.473.184-.93.516-1.262.336-.336.79-.527 1.262-.527Zm-.035 6.169V9.5'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M6.395 9.5c.777 0 1.41-.629 1.41-1.406h10.547c0 .777.632 1.406 1.41 1.406v3.055a1.41 1.41 0 0 0-1.41 1.414H7.805a1.408 1.408 0 0 0-1.41-1.414'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M4.297 8.574a1.81 1.81 0 0 0-1.809 1.809v5.84a1.81 1.81 0 0 0 1.809 1.808h13.5c1 0 1.808-.808 1.812-1.808v-.516'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconMakePayment
